import { render, staticRenderFns } from "./question-store.vue?vue&type=template&id=464b8918&scoped=true"
import script from "./question-store.vue?vue&type=script&lang=ts"
export * from "./question-store.vue?vue&type=script&lang=ts"
import style0 from "./question-store.vue?vue&type=style&index=0&id=464b8918&prod&lang=scss"
import style1 from "./question-store.vue?vue&type=style&index=1&id=464b8918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464b8918",
  null
  
)

export default component.exports